
import { Button } from "@/components/ui/button";
import { Edit, Lock, Unlock, Bell } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/hooks/use-toast";

interface ClientActionsProps {
  clientName: string;
  email: string |null;
  isBlocked: boolean;
  onRenewSubscription: () => void;
  onBlockClient: () => void;
  onSendReminder: () => void;
}

export function ClientActions({ 
  clientName, 
  email, 
  isBlocked, 
  onRenewSubscription, 
  onBlockClient , 
  onSendReminder
}: ClientActionsProps) {
  const { t } = useTranslation("clients");
  const { toast } = useToast();

  const handleUnblockClient = () => {
    toast({
      title: t("accountUnblocked"),
      description: t("accountUnblockedMessage", { name: clientName }),
      duration: 3000,
    });
  };


  return (
    <>
      
      {isBlocked ? (
        <Button variant="primary" className="w-full" onClick={handleUnblockClient}>
          <Unlock className="h-4 w-4 mr-2" />
          {t("unblockAccount")}
        </Button>
      ) : (
        <Button variant="destructive" className="w-full" onClick={onBlockClient}>
          <Lock className="h-4 w-4 mr-2" />
          {t("blockAccount")}
        </Button>
      )}
      
      <Button variant="purple" className="w-full" onClick={onSendReminder}>
        <Bell className="h-4 w-4 mr-2" />
        {t("sendReminder")}
      </Button>
    </>
  );
}
